/**
 * Verifica se uma data é válida (não é a data default/placeholder do Plone)
 * Plone usa "1969-12-31" como data padrão em vários campos
 * @param dateString - Data ISO string
 * @returns true se a data é válida e diferente de 1969-12-31
 */
export const isValidDate = (dateString?: string): boolean => {
  if (!dateString) return false;

  // Ignora datas default do Plone (1969-12-31)
  if (dateString.startsWith('1969-12-31')) {
    return false;
  }

  const date = new Date(dateString);
  return !Number.isNaN(date.getTime());
};

export default isValidDate;
